var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 32,
    viewBox: "0 0 132 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.665 28.0159C121.764 28.0159 120.504 27.6485 119.335 27.1891V24.4792C120.733 25.0992 122.359 25.3748 123.711 25.3748C126.346 25.3748 127.217 24.0198 127.217 21.8611V20.8276C126.461 21.9759 125.338 22.7338 123.665 22.7338C120.389 22.7338 119.06 20.8046 119.06 17.0152V10.1484H122.199V17.1301C122.199 19.174 122.841 20.2534 124.467 20.2534C126.094 20.2534 127.217 18.8755 127.217 17.1301V10.1484H130.356V21.9529C130.356 25.7882 127.927 28.0159 123.665 28.0159Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.333 22.6421V10.1487H113.473V12.1467C114.274 10.7917 115.558 9.82715 117.322 9.82715V12.9735C117.116 12.9275 116.909 12.9046 116.68 12.9046C114.756 12.9046 113.495 14.5122 113.473 16.9006V22.6421H110.333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1108 17.1762V15.6605C96.1108 11.7333 98.677 9.82715 101.999 9.82715C105.322 9.82715 107.934 11.7333 107.934 15.6605V17.1762C107.934 21.0804 105.322 22.9866 101.999 22.9866C98.677 22.9866 96.1108 21.0804 96.1108 17.1762ZM99.3186 15.6375V17.1762C99.3186 19.4269 100.327 20.5063 101.999 20.5063C103.672 20.5063 104.703 19.4269 104.703 17.1762V15.6375C104.703 13.3869 103.672 12.3304 101.999 12.3304C100.327 12.3304 99.3186 13.3869 99.3186 15.6375Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3991 18.7379V12.606H86.4058V10.1486H88.3991V6.56592H91.5382V10.1486H94.5397V12.606H91.5382V18.2785C91.5382 19.8402 92.0651 20.3225 93.2795 20.3225C93.7378 20.3225 94.3106 20.2766 94.723 20.1617V22.7339C94.196 22.8717 93.3024 22.9865 92.5921 22.9865C89.8426 22.9865 88.3991 21.4478 88.3991 18.7379Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5664 19.3119V5.30273H83.7054V18.4622C83.7054 19.8631 83.9345 20.3454 84.8969 20.3454C85.3551 20.3454 85.7675 20.2765 86.0196 20.1617V22.7109C85.5384 22.8717 84.7823 22.9865 84.1408 22.9865C81.7349 22.9865 80.5664 21.8612 80.5664 19.3119Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5161 19.3119V5.30273H76.6551V18.4622C76.6551 19.8631 76.8843 20.3454 77.8466 20.3454C78.3048 20.3454 78.7173 20.2765 78.9693 20.1617V22.7109C78.4881 22.8717 77.732 22.9865 77.0905 22.9865C74.6846 22.9865 73.5161 21.8612 73.5161 19.3119Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5345 9.82715C68.8568 9.82715 71.1938 11.7104 71.1938 15.5227V17.5437H63.1057C63.2432 19.5417 64.4805 20.3915 66.4739 20.3915C67.9861 20.3915 69.2234 20.2766 70.9189 19.381V21.8383C69.4067 22.6881 68.0319 22.9866 65.9698 22.9866C62.1205 22.9866 59.9209 20.9426 59.9209 17.1762V15.6605C59.9209 11.963 62.2121 9.82715 65.5345 9.82715ZM65.5345 12.3304C63.9993 12.3304 63.1516 13.3639 63.1057 15.3849H68.009C67.9861 13.272 67.1842 12.3304 65.5345 12.3304Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1001 10.1484H43.2162L45.37 19.4496L48.234 10.1484H51.0064L53.8247 19.4037L55.9555 10.1484H58.9571L55.4286 22.8716H52.2437L49.5859 14.0297L46.8135 22.8716H43.6744L40.1001 10.1484Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3479_6436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9467C0 7.76494 0 5.67408 0.813818 4.07687C1.52967 2.67193 2.67193 1.52967 4.07687 0.813818C5.67408 0 7.76494 0 11.9467 0H20.0533C24.2351 0 26.3259 0 27.9231 0.813818C29.3281 1.52967 30.4703 2.67193 31.1862 4.07687C32 5.67408 32 7.76494 32 11.9467V20.0533C32 24.2351 32 26.3259 31.1862 27.9231C30.4703 29.3281 29.3281 30.4703 27.9231 31.1862C26.3259 32 24.2351 32 20.0533 32H11.9467C7.76494 32 5.67408 32 4.07687 31.1862C2.67193 30.4703 1.52967 29.3281 0.813818 27.9231C0 26.3259 0 24.2351 0 20.0533V11.9467Z",
    fill: "#151A22"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3479_6436)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3479_6436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4603 12.871C27.2753 8.34001 23.9865 7.42682 22.4502 7.47072C20.4002 7.47072 18.6195 8.17888 17.1013 9.59377C16.5981 10.0628 15.7516 10.0007 15.254 9.52571C13.2537 7.61647 9.90742 7.3606 8.10923 8.26345C6.00845 9.31822 5.08057 11.1591 5.08057 13.1356C5.08054 21.0394 13.107 26.3025 16.2674 26.3025C18.901 26.3025 27.7344 19.5867 27.4603 12.871Z",
    fill: "url(#paint0_radial_3479_6436)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.52284 11.0288C6.39116 9.31699 8.76142 8.00018 10.3416 7.8685C11.7405 7.75192 13.7587 7.94496 15.4825 9.72683C15.8687 10.1261 16.4935 10.2145 16.881 9.8165C17.556 9.12328 18.1707 8.43005 20.3494 7.73682C18.7692 8.5269 17.8474 9.31699 16.0039 11.4239C14.7285 12.8814 13.1069 13.6625 10.7366 13.6625C9.28815 13.6625 6.6772 13.0355 6.52284 11.0288Z",
    fill: "#C92E00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.9791 16.5594C18.1052 16.8196 17.9746 17.044 17.6767 17.1885C17.3787 17.3329 17.0518 17.2146 16.9256 16.9544C16.7995 16.6943 16.9219 16.3908 17.2198 16.2463C17.5178 16.1018 17.8529 16.2992 17.9791 16.5594Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4632 20.2515C14.3785 19.975 14.542 19.7733 14.8586 19.6763C15.1752 19.5793 15.5246 19.8394 15.6093 20.1158C15.694 20.3923 15.4819 20.5804 15.1653 20.6775C14.8487 20.7745 14.5479 20.528 14.4632 20.2515Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63004 17.3497C8.54533 17.0732 8.70048 16.785 8.95276 16.7077C9.26935 16.6107 9.65814 16.8263 9.74285 17.1027C9.82756 17.3792 9.57198 17.517 9.25539 17.614C8.9388 17.711 8.66304 17.4574 8.63004 17.3497Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.178,
    cy: 12.2409,
    rx: 0.223858,
    ry: 0.263362,
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8495 17.901C13.8495 18.1192 13.6614 18.2961 13.3705 18.2961C13.0796 18.2961 12.8438 18.1192 12.8438 17.901C12.8438 17.6828 13.0796 17.6113 13.3705 17.6113C13.6614 17.6113 13.8495 17.6828 13.8495 17.901Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6125 20.7729C20.6125 20.9911 20.4244 21.168 20.1335 21.168C19.8426 21.168 19.5591 20.9911 19.5591 20.7729C19.5591 20.5547 19.8426 20.3516 20.1335 20.3516C20.4244 20.3516 20.6125 20.5548 20.6125 20.7729Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.09124 -0.488447C6.43824 -0.710931 4.43109 -0.240078 2.72754 0.924196C4.70518 2.05081 7.24368 4.15882 8.65628 7.25698C9.45134 9.00073 9.08006 11.7634 11.0577 12.7492C13.2397 13.8368 15.0601 11.294 15.578 10.2143C15.6722 9.55714 15.6063 7.82029 14.5892 6.13037C13.3179 4.01798 12.4834 4.02961 9.92762 1.76477C8.65628 0.638161 8.66391 -0.411369 8.09124 -0.488447Z",
    fill: "url(#paint1_linear_3479_6436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4735 11.9497C10.4735 12.1679 10.165 12.3448 9.9468 12.3448C9.72862 12.3448 9.55176 12.1679 9.55176 11.9497C9.55176 11.7316 9.72862 11.5547 9.9468 11.5547C10.165 11.5547 10.4735 11.7316 10.4735 11.9497Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1615 8.33171C14.405 8.32175 14.6174 8.68155 14.6281 8.94167C14.6387 9.2018 14.45 9.42074 14.2065 9.4307C13.963 9.44066 13.757 9.23786 13.7464 8.97773C13.7357 8.71761 13.9181 8.34166 14.1615 8.33171Z",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6663 4.12551C13.9098 4.11555 14.1268 4.58785 14.1407 4.92752C14.1546 5.26719 13.9685 5.55062 13.725 5.56058C13.4816 5.57054 13.2729 5.30325 13.259 4.96358C13.2451 4.62391 13.4229 4.13547 13.6663 4.12551Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5585 6.92693C17.6321 7.02749 17.5246 7.23136 17.4063 7.31787C17.2881 7.40438 17.1326 7.39299 17.059 7.29243C16.9854 7.19187 17.0216 7.04022 17.1399 6.95371C17.2581 6.86719 17.4849 6.82637 17.5585 6.92693Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7482 8.28536C16.8333 8.40159 16.735 8.61815 16.6168 8.70466C16.4985 8.79117 16.3337 8.76709 16.2487 8.65087C16.1637 8.53465 16.1906 8.3703 16.3088 8.28379C16.427 8.19727 16.6632 8.16914 16.7482 8.28536Z",
    fill: "#FF6B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5657 6.40193C15.45 6.31625 15.4794 6.08026 15.5666 5.96251C15.6537 5.84476 15.8182 5.81875 15.934 5.90443C16.0497 5.99011 16.0729 6.15503 15.9857 6.27278C15.8986 6.39054 15.6815 6.48761 15.5657 6.40193Z",
    fill: "#FEA900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5803 2.20458C12.4367 2.19347 12.4373 2.08729 12.4486 1.94122C12.4599 1.79515 12.4592 1.63039 12.6028 1.6415C12.7464 1.65261 12.8536 1.78003 12.8423 1.9261C12.831 2.07216 12.7239 2.21569 12.5803 2.20458Z",
    fill: "#CC5616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.189 4.96986C17.0732 4.88418 17.1507 4.7582 17.189 4.7065C17.3052 4.54948 17.5163 4.26137 17.584 4.31145C17.6796 4.38219 17.6099 4.64919 17.4936 4.80621C17.4301 4.89198 17.3047 5.05554 17.189 4.96986Z",
    fill: "#E39932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44523 2.86331C7.1292 2.65262 6.91851 2.46826 6.65514 2.46826C5.86506 2.46826 6.12842 3.65339 6.39178 4.04844C6.65514 4.44348 7.44523 4.70684 7.70859 4.57516C7.97196 4.44348 7.97196 4.18012 7.97196 3.91676C7.97196 3.65339 7.84027 3.12667 7.44523 2.86331Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7906 6.68239C11.1322 6.18858 10.386 5.05832 9.94704 4.44381C9.71966 4.12551 9.55514 4.44381 9.552 4.70717C9.552 4.97052 9.52367 6.99577 10.0787 7.73584C10.8688 8.78927 11.2638 8.78927 11.7906 8.26256C12.1263 7.92685 12.3173 7.07743 11.7906 6.68239Z",
    fill: "#FF5B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89324 9.05198C8.89324 8.78862 8.36651 8.2619 7.97147 7.73518C7.65543 7.3138 7.22528 7.29624 7.0497 7.34013C6.96191 7.34013 6.76 7.41913 6.65465 7.73517C6.52297 8.13021 6.78634 8.52526 7.0497 8.65694C7.16748 8.71583 7.70811 8.78862 8.10315 9.18366C8.43887 9.51939 8.89324 9.31535 8.89324 9.05198Z",
    fill: "#FF6B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.947 11.6773C14.5046 12.0439 13.5732 12.5974 12.9498 12.8066C12.8144 12.852 12.6739 12.7758 12.6218 12.6428C12.3937 12.0607 12.2013 11.4787 12.3177 10.8966C12.5459 9.75562 13.0639 9.79926 13.3712 9.97484C13.9471 10.3039 14.6159 10.3642 15.0202 11.3824C15.0616 11.4867 15.0334 11.6057 14.947 11.6773Z",
    fill: "#FF6B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3479_6436",
    x: -12.3071,
    y: -7.93408,
    width: 55.5757,
    height: 57.9399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.90088
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.90088
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.327091 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3479_6436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3479_6436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3479_6436",
    x: 1.13013,
    y: 3.5188,
    width: 26.3362,
    height: 22.7834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.95044,
    dy: -3.95044
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.95044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_3479_6436"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3479_6436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6357 9.30633) rotate(82.9327) scale(19.2493 18.3491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502537,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767781,
    stopColor: "#B80747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3479_6436",
    x1: 9.15807,
    y1: 9.00057,
    x2: 4.79703,
    y2: -0.55884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3479_6436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.da93a8e5.svg";
export { ForwardRef as ReactComponent };